type ScrollPosition = { top: number; left: number };

// Inertia stores the document scroll position in history.state on every scroll
// event (debounced). Scrolling synchronously after mount ensures the correct
// position is applied before the browser paints: in CSR mode (no SSR content)
// native restoration has no content to scroll to until Vue mounts; in SSR mode
// this acts as a safety net when native restoration is late or skipped.
export function restoreScrollPosition(): void {
    const pos = window.history.state?.documentScrollPosition as ScrollPosition | undefined;

    if (!pos || (pos.top <= 0 && pos.left <= 0)) {
        return;
    }

    window.scrollTo(pos.left, pos.top);
}
